import { ButtonClassKey, ButtonProps } from "@mui/material/Button";
import { CSSProperties } from "@mui/styles";
import { primaryPalette } from "./PaletteOverrides";

export const buttonDefaultProps: Partial<ButtonProps> = {
  variant: "contained",
  color: "primary",
  size: "large",
};

export const buttonOverrides: Partial<Record<ButtonClassKey, CSSProperties>> = {
  contained: {
    "&:hover": {
      backgroundColor: primaryPalette.main,
      opacity: "0.8",
    },
    "&:disabled": {
      backgroundColor: primaryPalette.main,
      color: primaryPalette.contrastText,
      opacity: 0.4,
      boxShadow: "",
    },
  },
};
